import React from 'react';
import css from '@/css/module/new-world.css';
import { useLoadRows_LEGACY } from '@/features/query-builder/hooks/LEGACY';

export const NoResults = () => {
  const { dataTable } = useLoadRows_LEGACY();

  if (!dataTable || dataTable.rows().length > 0) {
    return null;
  }

  return <div className={css.noResultsContainer}>0 results found</div>;
};
